<template>
  <div>
    <Header/>
    <advanceSearch/>
  </div>
</template>
<script>
// @ add advance search component to page alogn with header
import Header from '@/components/header.vue'
import advanceSearch from '@/components/advanceSearch.vue'
export default {
  name: 'home',
  components: {
    Header,
    advanceSearch
  }
}
</script>
